export default {
  form: {
    shipping_company_name: {
      label: 'Azienda',
      placeholder: "Inserisci il nome dell'azienda",
    },
    shipping_phone_number: {
      label: 'Numero di telefono',
      placeholder: 'Inserisci il numero di telefono',
    },
    shipping_salutation: {
      label: 'Titolo',
      options: {
        mr: 'Sig.',
        mrs: 'Sig.ra',
      },
    },
    shipping_first_name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome',
    },
    shipping_last_name: {
      label: 'Cognome',
      placeholder: 'Inserisci il cognome',
    },
  },
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
  },
};
